import React, { FunctionComponent, ReactElement } from 'react';
import { ModalWrapper, ModalInner } from './modal-styled-components';

export interface FormModalProps {
  show: boolean;
  onClose: () => void;
  children: ReactElement;
}

/**
 * Currently only used for add bot for customers who are not using automation lookup
 * v2. We could potentially keep and reuse this form modal component. Maybe add standard
 * behavior and components for submitting and canceling the form.
 * @param param0
 * @deprecated
 * @returns
 */
const FormModal: FunctionComponent<FormModalProps> = ({
  onClose, children, show,
}: FormModalProps) => {
  const closeModal = () => {
    const confirmation = window.confirm(
      'Are you sure you want to close this modal? Your changes will not be saved.',
    );

    if (confirmation && onClose) {
      onClose();
    }
  };

  return show ? (
    <ModalWrapper
      onClick={closeModal}
    >
      <ModalInner
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </ModalInner>
    </ModalWrapper>
  ) : null;
};

export default FormModal;
